import { useState } from "react";
import { API } from "../../../services/api";
import { FieldLabel } from "../AdminCommon";
import { btnPurpleFilledStyle, cardStyle, inputStyle } from "../styles/adminDashboardStyles";

export function MaintenanceTab() {
    const [running, setRunning] = useState(false);
    const [result, setResult] = useState(null);
    const [lookbackHours, setLookbackHours] = useState(25);

    const handleCatchup = async () => {
        setRunning(true);
        setResult(null);
        try {
            const { data } = await API.post("/admin/mail-catchup", { lookbackHours: Number(lookbackHours) });
            setResult({ ok: true, message: data.message });
        } catch {
            setResult({ ok: false, message: "Une erreur est survenue lors de la vérification." });
        } finally {
            setRunning(false);
        }
    };

    return (
        <div>
            <div style={cardStyle}>
                <div style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}>
                    <div style={{ width: "52px", height: "52px", borderRadius: "14px", background: "#ede9fe", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px", flexShrink: 0 }}>
                        ✉️
                    </div>
                    <div style={{ flex: 1 }}>
                        <h2 style={{ fontSize: "17px", fontWeight: 700, color: "#111827", margin: 0, marginBottom: "8px" }}>
                            Vérification des mails
                        </h2>
                        <p style={{ fontSize: "14px", color: "#6b7280", lineHeight: 1.6, margin: 0, marginBottom: "20px" }}>
                            Repasse sur la fenêtre choisie de la boîte mail et s'assure que tous les mails ont bien
                            été importés dans la plateforme. Cette opération est sans risque : les doublons sont
                            ignorés automatiquement.
                        </p>
                        <div style={{ display: "flex", alignItems: "flex-end", gap: "12px", flexWrap: "wrap" }}>
                            <div style={{ width: "170px" }}>
                                <FieldLabel htmlFor="admin-mail-catchup-hours">Fenêtre</FieldLabel>
                                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                    <input
                                        id="admin-mail-catchup-hours"
                                        type="number"
                                        min="1"
                                        max="168"
                                        step="1"
                                        value={lookbackHours}
                                        onChange={e => setLookbackHours(e.target.value)}
                                        style={{ ...inputStyle, width: "96px" }}
                                    />
                                    <span style={{ fontSize: "13px", color: "#6b7280", fontWeight: 600 }}>heures</span>
                                </div>
                            </div>
                            <button onClick={handleCatchup} disabled={running || Number(lookbackHours) < 1 || Number(lookbackHours) > 168} style={btnPurpleFilledStyle}>
                                {running ? "Vérification en cours…" : "Relancer la vérification des mails"}
                            </button>
                        </div>
                        {result && (
                            <p style={{ marginTop: "12px", fontSize: "13px", color: result.ok ? "#15803d" : "#dc2626", fontWeight: 500 }}>
                                {result.message}
                            </p>
                        )}
                    </div>
                </div>

                <div style={{ borderTop: "1px solid #f3f4f6", marginTop: "24px", paddingTop: "20px", display: "flex", gap: "40px" }}>
                    {[
                        { label: "Dernière vérification", value: result ? "À l'instant" : "—" },
                        { label: "Mails importés (24 h)", value: "—" },
                        { label: "Doublons ignorés", value: "—" },
                    ].map(stat => (
                        <div key={stat.label}>
                            <div style={{ fontSize: "11px", fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.6px", marginBottom: "4px" }}>
                                {stat.label}
                            </div>
                            <div style={{ fontSize: "16px", fontWeight: 700, color: "#111827" }}>{stat.value}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
